import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Tabs } from '@material-ui/core';
import styles from './styles';

export default withStyles(styles.customTabs)(
  props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);
